import React, { useEffect } from "react";
import styled from 'styled-components'
import {GetSearchDetail} from '../api'
import { formatEPSG4326 } from '../common/utils';
const AddressStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
`
const querystring = require('querystring');   

const AddrList = ({match})=> {
  useEffect(() => {
    const addr = querystring.parse(match.params.query);
    GetSearchDetail(addr)
    .then((res => {
      const { results } = res.data;
      if (results.juso && results.juso.length > 0){
        const { entX, entY } = results.juso[0];
        const { x, y } = formatEPSG4326(entX, entY);
        addr.longitude = x;
        addr.latitude = y;
        window.opener.setChildValue(addr);
      } else {
        window.opener.setChildValue(addr);
      }
      window.close();
    }))
  }, [match])
  return (
    <AddressStyles/>
  );
};

export default AddrList;